export const EVENTS = {
  LOGGED_IN: 'LoggedIn',
  TASK_CALENDAR: 'TaskCalendar',
  FEEDBACK: 'Feedback',
  AssemblerUpload: 'AssemblerUpload',
  AssemblerDownload: 'AssemblerDownload',
};
